const WorkshopSection = () => {

  return (
    <section className="w-full py-[100px] bg-[#E6F3CD]">
        <div className="w-full flex items-center justify-center"> 
            <div className="w-[80%] md:w-[60%] flex flex-col justify-center items-center">
                <div className="w-full h-full bg-[#D4A373] bg-opacity-40 text-[#41220E] py-12 xs:px-[20px] px-[50px] sm:px-[70px] mb-8">
                    <h1 className="font-bold font-playfair xs:text-3xl text-4xl text-center">Bakery & Pastry Workshop</h1>
                    <p className="font-semibold font-playfair xs:text-lg text-xl sm:text-[22px] italic text-center mt-10">Immerse yourself in the art of baking with workshops tailored for all skill levels, from beginners to seasoned bakers. 
                        Discover the joy of creating delicious breads, pastries, and desserts with hands-on guidance.</p>
                </div>
                <a href='#signup-form'>
                    <button className="bg-[#F5E9D7] text-[#41220E] font-bold font-playfair text-[20px] border-solid border-2 border-[#41220E] rounded-[50px] py-5 px-10">SIGN UP NOW</button>
                </a>
            </div>
        </div>
    </section>
  )
}

export default WorkshopSection
